import { useEffect, useRef, useSyncExternalStore, type ReactNode } from 'react';
import { GenericErrorPage } from 'components/errorpages/GenericErrorPage';
import { isChunkRecoveryBlocked, subscribeToChunkRecovery } from 'utils/chunkLoadRecovery';

interface ChunkLoadRecoveryRootProps {
  children: ReactNode;
}

export function ChunkLoadRecoveryRoot({ children }: ChunkLoadRecoveryRootProps) {
  const isBlocked = useSyncExternalStore(subscribeToChunkRecovery, isChunkRecoveryBlocked, isChunkRecoveryBlocked);
  const blockedPageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isBlocked) blockedPageRef.current?.focus();
  }, [isBlocked]);

  if (isBlocked) {
    return (
      <div ref={blockedPageRef} tabIndex={-1} data-testid="chunk-load-blocked-page">
        <GenericErrorPage />
      </div>
    );
  }

  return children;
}
